<template lang="pug">
v-container.fill-height.pa-0(fluid)
  HomeBackground(v-if="selectedHome === 'background'")
  HomeFunctions(v-else)
</template>

<script>
import HomeBackground from "@/components/home/HomeBackground.vue";
import HomeFunctions from "@/components/home/HomeFunctions.vue";
import { SELECTED_HOME } from "@/env.js";
export default {
  name: "HomeView",
  components: {
    HomeBackground,
    HomeFunctions,
  },
  data() {
    return {
      selectedHome: "",
    };
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      this.selectedHome = SELECTED_HOME ? SELECTED_HOME : "";
    } else {
      this.selectedHome = process.env.VUE_APP_SELECTED_HOME
        ? process.env.VUE_APP_SELECTED_HOME
        : "";
    }
  },
};
</script>

<style lang="sass" scoped></style>
